export default class OfferUrlFactory {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl.replace(/\/$/, '');
    }

    public pl(offerId: string): string {
        return this.url(offerId);
    }

    public en(offerId: string): string {
        return this.url(offerId + '?lang=en');
    }

    public url = (path: string): string => {
        return this.baseUrl + ('/' + path).replace('//', '/');
    }
}